// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.page-content .summary-card .card-header .summary-name[data-v-0bd4a72d] {\n  padding-left: 35px;\n  padding-top: 4px;\n  font-weight: 600;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
